<template>
  <el-dialog
    title="阶梯信息"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
      label-width="90px">
      <el-form-item
        label="分段金额:"
        prop="totalAmount">
        <el-input-number
          v-model="ruleForm.totalAmount"
          style="width: 90%"
          :min="0.01"
          :precision="2"
          :max="99999999"></el-input-number>元
      </el-form-item>
      <el-form-item
        label="返现比例:"
        prop="cashbackPercent">
        <el-input-number
          v-model="ruleForm.cashbackPercent"
          style="width: 90%"
          :min="0"
          :precision="2"
          :max="100"></el-input-number>%
      </el-form-item>
      <el-form-item
        label="提成比例:"
        prop="commissionPercent">
        <el-input-number
          v-model="ruleForm.commissionPercent"
          style="width: 90%"
          :min="0"
          :precision="2"
          :max="100"></el-input-number>%
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'VipUpgradeInfoModal',
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { totalAmount: 0, cashbackPercent: 0, commissionPercent: 0 },
      rules: {
        totalAmount: [
          { required: true, message: '请填写分段金额', trigger: 'change' }
        ],
        cashbackPercent: [
          { required: true, message: '请填写返现比例', trigger: 'change' }
        ],
        commissionPercent: [
          { required: true, message: '请填写提成比例', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$emit('update', this.ruleForm, this)
          // this.visible = false
        }
      })
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
